import { styled as muiStyled, css } from '@mui/material/styles';
import { ComputedDatum } from '@nivo/pie';
import React from 'react';

import { GraphDatum } from './_type';

import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface Props extends ComputedDatum<GraphDatum> {
  className?: string;
}

const TooltipImpl: React.FC<Props> = ({
  className,
  id,
  formattedValue,
  data,
}) => {
  // Special empty value should not have a tooltip
  if (id === 'empty-value-id') {
    return null;
  }

  const displayValue = data.tooltipLabel ?? parseInt(formattedValue, 10);

  return (
    <div className={className}>
      <Text sz="body12">{`${id}: ${displayValue}`}</Text>
    </div>
  );
};

export const Tooltip = muiStyled(TooltipImpl)(
  ({ theme }) => css`
    background-color: ${theme.palette.background.paper};
    color: ${theme.palette.text.primary};
    padding: ${theme.spacing(spc.container_padding_s)};
    border-radius: 4px;
  `
);

export default Tooltip;
